import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';
import type { PriceType } from '@/types/common.ts';

const DefaultPriceType = () => {
  const { formatMessage } = useIntl();
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = ({ value }: { defaultPriceType: string; value: string }): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, option tab, default price type', value);
    updateUserPreferences({ ...userPreferences, defaultPriceType: value as PriceType });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="default-price-type">
        <FormattedMessage id="userPreferences.label.defaultPriceType" />
      </label>
      <Select
        id="default-price-type"
        itemValue={(item) => item.value}
        selectedItemValue={userPreferences.defaultPriceType}
        itemsAsObjects={[
          { defaultPriceType: formatMessage({ id: 'userPreferences.label.defaultPriceType.amount' }), value: 'AMOUNT' },
          {
            defaultPriceType: formatMessage({ id: 'userPreferences.label.defaultPriceType.volatility' }),
            value: 'VOLATILITY',
          },
          {
            defaultPriceType: formatMessage({ id: 'userPreferences.label.defaultPriceType.percent' }),
            value: 'PERCENT',
          },
          { defaultPriceType: formatMessage({ id: 'userPreferences.label.defaultPriceType.pps' }), value: 'PPS' },
        ]}
        itemToString={({ defaultPriceType }) => defaultPriceType}
        onChange={handleChange}
        className="w-auto"
      />
    </div>
  );
};

export default DefaultPriceType;
